import React from 'react'
import { FaRegStar, FaStar, FaStarHalfAlt } from 'react-icons/fa'

type Props ={
    rating:number
}

function StartRatings({rating}:Props) {
    const starts =[]

    for (let i = 1; i <= 5; i++) {
        if(rating >= i){
            starts.push(<FaStar key={i} className='text-yellow-400'/> )
        }else if(rating>=i-0.5){
            starts.push(<FaStarHalfAlt key={i} className='text-yellow-400' />)
        }else{
            starts.push(<FaRegStar key={i} className='text-gray-300' />)
        }
    }
  return (
    <div className="flex space-x-1">{starts}</div>
  )
}

export default StartRatings
